import SwitchInput from "./SwitchInput";

export type { SwitchInputProps } from "./SwitchInput";

export default SwitchInput;
